import { Tooltip, tooltipClasses, TooltipProps } from '@mui/material'
import styled from 'styled-components'

interface LightTooltipStyledProps extends TooltipProps {
  style?: React.CSSProperties
  tooltipModalStyle?: React.CSSProperties
  tooltipContainerStyle?: React.CSSProperties
}

export const LightTooltip = styled(
  ({
    className,
    tooltipContainerStyle,
    style,
    ...props
  }: LightTooltipStyledProps) => (
    <Tooltip
      {...props}
      style={{ ...style, ...tooltipContainerStyle }}
      classes={{ popper: className }}
    />
  ),
)(({ theme, style, tooltipModalStyle }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.colors.Grey10,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: `-7px 6px 17px 0px rgba(0,0,0,0.29)`,
    fontSize: 10,
    padding: theme.space.sm,
    width: 'auto',
    maxWidth: 'none',
    ...style,
    ...tooltipModalStyle,
  },
}))
